const API_PROD = "https://auth.rosalyna.be/";

/** Base URL API : proxy local en dev, prod sinon. */
function resolveApiBaseUrl(): string {
  const fromEnv = (process.env.VUE_APP_API_BASE_URL || "").trim();
  if (fromEnv) {
    return fromEnv.endsWith("/") ? fromEnv : `${fromEnv}/`;
  }
  if (process.env.NODE_ENV === "development") {
    return "/";
  }
  return API_PROD;
}

export const devEnvironment = {
  production: false,
  apiKey: "",
  baseUrl: "https://dev.rosalyna.be/",
};

export const prodEnvironment = {
  production: process.env.NODE_ENV === "production",
  apiKey: "",
  baseUrl: resolveApiBaseUrl(),
};

export const localEnvironment = {
  production: false,
  apiKey: "",
  baseUrl: "http://localhost:8900/",
};
